/** All routes configurations */
export default [
  { path: '/',
    name: 'DecodeToken',
    component: () => import('@/views/DecodeTokenPage'),
    props: route => ({ token: route.query.token }),
    children: [
      {
        path: '/auth',
        name: 'login',
        component: () => import('@/views/AuthLoginRegisterPage'),
      },
      {
        path: '/error',
        name: 'error',
        component: () => import('@/views/AuthErrorPage'),
      },
      {
        path: '/info',
        name: 'info',
        component: () => import('@/views/AuthInfoPage'),
      },
    ],
  },
  {
    path: '/test',
    component: () => import('@/views/Test'),
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js